import React, {useState} from 'react';
import Button from "@mui/material/Button";

const Counter = () => {
    const [counterOne, setCounterOne] = useState(0);
    const [counterTwo, setCounterTwo] = useState(0);

    const incrementCounterOne = ()=>{
        setCounterOne(counterOne+1);
    }
    const incrementCounterTwo = ()=>{
        setCounterTwo(counterTwo+1);
    }



    return (

        <div>
            <Button color={"secondary"} onClick={incrementCounterOne}>Increment Counter One - {counterOne}</Button>

            <Button onClick={incrementCounterTwo}>Increment Counter Two -{counterTwo}</Button>
        </div>
    );
};

export default Counter;
